module.exports = __webpack_public_path__ + "img/BLCA_Plasma.5617b9da.png";